kv.controller('customerListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'customer_id';
	vm.entity = 'customer';

	vm.count = {
		total: 0,
		showing: 0
	};

	vm.getInfinitScroll({
		params: {
			action: 'customer'
		},
		url: "customer",
	});

	vm.getMergedIndustries = function(entity) {
		if (!entity.industries) return '-';
		return entity.industries.map(function(industry) { return industry.industry_name; }).join(', ');
	};

	vm.getMergedResponsibles = function(entity) {
		if (!entity.responsibles) return '-';
		return entity.responsibles.map(function(user) { return user.full_name; }).join(', ');
	};

	vm.disableCustomers = function () {
		vm.confirm( vm.trans("LANG.LINES_NO")  + ' ' + vm.infinitScroll.total, vm.trans("LANG.CONFIRM_THE_CHANGES")).then(response => {
			if (response !== "ok") return;
			let postData = angular.copy(vm.infinitScroll.search);
			KApp.block('.k_content_body');
			vm.rest.getArray({
				url: vm.entity + '/bulk/disableCustomers?' + $filter("objToParams")(vm.infinitScroll.search),
				data: postData
			}).then(function (data) {
				KApp.unblock('.k_content_body');
				if(data.error && data.error.error_code === 1){
					toastr.error(data.error.message);
				}else{
					vm.infinitScroll.search.refresh++;
				}
			});
		});
	};

	// vm.delete = function deleteEntity($index) {
	// 	$http.delete("customer/" + vm.infinitScroll.items[$index][vm.primaryKey]).then(function () {
	// 		vm.infinitScroll.items.splice($index, 1);
	// 	});
	// };

	return vm;
});

